"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogStatementSchema = void 0;
const zod_extensions_1 = require("@reachmedianetwork/zod-extensions");
exports.LogStatementSchema = zod_extensions_1.z.object({
    message: zod_extensions_1.z.string().optional(),
    payload: zod_extensions_1.z.nullable(zod_extensions_1.z.record(zod_extensions_1.z.any())).optional(),
}).passthrough();
//# sourceMappingURL=logStatement.js.map